export const CONTROLS = {
  ORBIT: 'orbit',
  DEVICE: 'device',
};

export const DEFAULT_AUTO_ROTATE_SPEED = 3;
